import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { NbDialogService, NbToastrService } from '@nebular/theme';
import { BaseComponent } from '../../../../shared/Components/base/base.component';
import { AddDspaceStatisticsComponent } from '../../../dspace-statistics/components/add-dspace-statistics/add-dspace-statistics.component';
import { DspaceStatisticsService } from '../../../dspace-statistics/services/dspace-statistics-service';
import { ComplexInfoService } from '../../services/complex-info-service';
import { CreateComplexInfoComponent } from '../create-complex-info/create-complex-info.component';
import { DeleteConfirmationComponent } from '../../../delete-confirmation/delete-confirmation.component';

@Component({
  selector: 'app-get-complex-info',
  templateUrl: './get-complex-info.component.html',
  styleUrls: ['./get-complex-info.component.scss']
})
export class GetComplexInfoComponent extends BaseComponent implements OnInit {
  dateTo: string;
  dateFrom: string;
  form: FormGroup;
  constructor(
    public service: ComplexInfoService,
    route: Router,
    private fb: FormBuilder,
    private diag: NbDialogService,
    private toast: NbToastrService
  ) {
    super(route, service, null, '', diag);
  }

  ngOnInit() {
    this.loadEntities();
  }

  addNew() {
    this.dialog
      .open(CreateComplexInfoComponent, {
        dialogClass: 'custom-dialog-height',
      })
      .onClose.subscribe((res) => {
        if (res === 'true') this.loadEntities();
      });
  }

    delete(id) {
    this.diag.open(DeleteConfirmationComponent, {
      dialogClass: 'custom-dialog-height',
      context: {
        id: id,
        service: this.service,
        url:this.route.url
      },
    });
  }

  update(model) {
    const copymodel = {...model}
    this.diag
      .open(CreateComplexInfoComponent, {
        dialogClass: 'custom-dialog-height',
        context: {
          model: copymodel,
          isEdit: true,
        },
      })
      .onClose.subscribe((res) => {
        if (res === 'true') this.loadEntities();
      });
  }
}
